import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';

function NewConsultingIndividualCategoryDetailTypeLandingPage({
  page: { MainContent, breadCrumbList },
  section,
}) {
  const HeroComponent = React.lazy(() =>
    import('./new-consulting-individual-category-detail-type-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-consulting-individual-category-detail-type-content')
  );

  return (
    <div className={`consulting consulting-tertiary ${section || ''}`}>
      <div className="industries industries-lp">
        <Suspense fallback={<Loader />}>
          <HeroComponent
            MainContent={MainContent}
            section={section}
            breadCrumbList={breadCrumbList}
          />
        </Suspense>
        <Suspense fallback={<Loader />}>
          <ContentComponent section={section} MainContent={MainContent} />
        </Suspense>
      </div>
    </div>
  );
}

export default NewConsultingIndividualCategoryDetailTypeLandingPage;
